<div *ngIf="flagActive && authorized && bookmarksPreviewFlag">
  <app-searchable-bookmarks-results-preview
    [preview]="preview"
    [loading]="loading"
    [hideCount]="true"
    (openList)="openAvailableList()"
  >
  </app-searchable-bookmarks-results-preview>
</div>
